import { cn } from "../../../lib/utils";
import React from "react";
import { StatusCircle, StatusDoneCheck } from "./status-circle";
import { StatusCounts, isAllDone } from "../../../data/project-progress";
import { formatDeliverableId } from "../../../lib/projects/utils";

export function DeliverableCard(props: {
    onClick?: () => unknown;
    workstreamId: string;
    workstreamIndex?: number;
    deliverableIndex?: number;
    deliverable: { id: string; name: string; description: string };
    className?: string;
    statusCounts?: StatusCounts;
}) {
    const { deliverable, onClick } = props;
    const allDone = props.statusCounts != null && isAllDone(props.statusCounts);
    const icon = (
        <DeliverableIcon
            workstreamId={props.workstreamId}
            deliverableId={deliverable.id}
            workstreamIndex={props.workstreamIndex}
            deliverableIndex={props.deliverableIndex}
        />
    );
    return (
        <div
            onClick={onClick}
            className={cn(
                "flex flex-col gap-2 rounded-md border p-4",
                !!onClick && "cursor-pointer transition-all hover:bg-accent",
                props.className
            )}
        >
            <div className={"flex flex-row items-center gap-2"}>
                {props.statusCounts ? (
                    <StatusCircle counts={props.statusCounts} size="sm">
                        {icon}
                    </StatusCircle>
                ) : (
                    icon
                )}
                {allDone && <StatusDoneCheck />}
            </div>
            <div>
                <div className={"font-medium"}>{deliverable.name}</div>
                <div className={"mt-1 text-sm text-muted-foreground"}>{deliverable.description}</div>
            </div>
        </div>
    );
}

export function DeliverableIcon(props: {
    workstreamId?: string;
    deliverableId?: string;
    workstreamIndex?: number;
    deliverableIndex?: number;
    size?: "xs";
    inline?: boolean;
    className?: string;
}) {
    return (
        <div
            className={cn(
                "flex h-8 w-8 shrink-0 flex-col items-center justify-center rounded-full border-2 border-foreground/5 text-sm font-semibold text-foreground/50",
                props.size === "xs" && "h-7 w-7 text-xs",
                props.inline && "inline-flex",
                props.className
            )}
        >
            {formatDeliverableId(props.workstreamIndex, props.deliverableIndex)}
        </div>
    );
}
